import type { IconSvgObject } from './types';

const CircleSlashIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 3L3 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CircleSlashIcon;
